import Select, { components } from 'react-select';

const CustomValueContainer = ({ children, ...props }) => {
  const [values, input] = children;
  const maxToShow = 2; // show 2 selected items, rest as +N more
  const selected = props.getValue();
  const displayValues = selected.slice(0, maxToShow);
  const hiddenCount = selected.length - maxToShow;

  return (
    <components.ValueContainer {...props}>
      {displayValues.map((val) => (
        <components.MultiValue {...props} data={val} key={val.value}>
          <components.MultiValueLabel {...props} data={val}>
            {val.label}
          </components.MultiValueLabel>
        </components.MultiValue>
      ))}
      {hiddenCount > 0 && (
        <span style={{ fontSize: '12px', color: '#555', marginLeft: 4 }}>
          +{hiddenCount} more
        </span>
      )}
      {input}
    </components.ValueContainer>
  );
};
export default CustomValueContainer